/**
 * Feature flags for premium 3D/interactive components.
 *
 * Every flag can be:
 *   1. Overridden from the environment via `REACT_APP_ENABLE_3D_*`
 *   2. Force-disabled site-wide by adding `?legacy=1` to the URL (safety valve)
 *   3. Force-disabled by a single user via localStorage: `localbest_disable_3d=1`
 *
 * Defaults are `true` in preview so we can validate the effects; a redeploy
 * with the env var set to `false` is the fastest kill-switch in production.
 */

const DEFAULTS = {
  ENABLE_3D_HOMEPAGE_HERO: true,
  ENABLE_3D_CATEGORY_WHEEL: true,
  ENABLE_3D_LISTING_CARDS: true,
  ENABLE_3D_MARKET_MAP: true,
  ENABLE_3D_AWARD_BADGE: true,
  ENABLE_3D_LISTING_HERO: true,
};

function envFlag(name, fallback) {
  const raw = process.env?.[`REACT_APP_${name}`];
  if (raw === undefined) return fallback;
  return String(raw).toLowerCase() !== "false" && raw !== "0";
}

function globalKillSwitch() {
  if (typeof window === "undefined") return false;
  try {
    if (new URLSearchParams(window.location.search).get("legacy") === "1") return true;
    if (window.localStorage?.getItem("localbest_disable_3d") === "1") return true;
  } catch {
    /* ignore */
  }
  return false;
}

export function isFeatureEnabled(name) {
  if (!(name in DEFAULTS)) return false;
  if (globalKillSwitch()) return false;
  return envFlag(name, DEFAULTS[name]);
}

// Convenience hooks-free named getters so components can `import { flags } from ...`
export const flags = new Proxy(
  {},
  {
    get(_target, key) {
      return isFeatureEnabled(key);
    },
  },
);

export default flags;
